module.exports = {"name":"马克思主义伦理学","id":1,"a":"来源：评奖数据库","if_collect":false,"Reading_volume":999,"publish_time":"2018-12-12","press":"北京大学出版社","reference":"北京大学","c":"作者/编辑：罗国杰","img":"static/img/book/1.png","catalogue":["第一章 推进人民代表大会制度理论与实践创新的必然性","一、人民代表大会制度是我国的根本政治制度 ","二、人民代表大会制度具有强大生命力和巨大优越性 ","三、人民代表大会制度需要与时俱进地发展和完善 ","第二章 人民代表大会制度理论的创新 ","一、人民代表大会制度是保障实现中华民族伟大复兴的好制度 ","二、支持和保证人民通过人民代表大会行使国家权力 ","三、推动人民代表大会制度与时俱进 ","第三章 人民代表大会制度在国家层面实践的创新","一、在选举制度方面 ","二、在立法工作方面 ","三、在监督工作方面 ","四、在代表工作方面 ","五、在加强自身建设方面 ","六、推进基层人大工作和制度建设 "],"d":"内容摘要：概述系统的阐述了马克思主义伦理学的基本理论，共产主义道德的原则、规范和范畴体系，人生观和行为品质。"}


//////////////////
// WEBPACK FOOTER
// ./static/json/detail.json
// module id = ygz+
// module chunks = 1